export const FEATURE_NAMESPACE = 'feature.lab-quality-result'
